export default "__VITE_ASSET__f47b9c9f__"